import palette from './palette';
import custom from './custom';

export default {
  fontFamily: 'Akkurat LL, Helvetica, Arial, sans-serif',
  h1: {
    color: custom.slate,
    fontWeight: 500,
    fontSize: '35px',
    letterSpacing: '-0.24px',
    lineHeight: '40px'
  },
  h2: {
    color: custom.slate,
    fontWeight: 400,
    fontSize: '28px',
    letterSpacing: '-0.03em',
    lineHeight: 1.2,
    marginBottom: 8
  },
  h3: {
    color: custom.slate,
    fontWeight: 500,
    fontSize: '24px',
    letterSpacing: '-0.06px',
    lineHeight: '28px'
  },
  h4: {
    color: custom.slate,
    fontWeight: 500,
    fontSize: '20px',
    letterSpacing: '-0.06px',
    lineHeight: '24px'
  },
  h5: {
    color: custom.slate,
    fontWeight: 500,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  },
  h6: {
    color: custom.slate,
    fontWeight: 500,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '20px'
  },
  subtitle1: {
    color: custom.slate,
    fontSize: '16px',
    letterSpacing: '-0.05px',
    lineHeight: '25px'
  },
  subtitle2: {
    color: palette.text.secondary,
    fontWeight: 400,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px'
  },
  body1: {
    color: custom.slate,
    fontSize: '14px',
    letterSpacing: '-0.05px',
    lineHeight: '21px'
  },
  body2: {
    color: custom.slate,
    fontSize: '14px',
    letterSpacing: '0',
    lineHeight: '22px',
  },
  button: {
    color: custom.slate,
    fontSize: 18,
    lineHeight: 1.56,
    fontWeight: 700,
    letterSpacing: 0,
    textTransform: 'none'
  },
  caption: {
    color: palette.text.secondary,
    fontSize: '11px',
    letterSpacing: '0.33px',
    lineHeight: '13px'
  },
  overline: {
    color: palette.text.secondary,
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.33px',
    lineHeight: '13px'
  }
};
